import React, {useContext, useEffect, useMemo, useState} from "react";

import {ProductCustomizerVariantContext} from "@contexts/ProductCustomizerVariant.jsx"
import AjaxPage from "@components/general/AjaxPage.jsx"

export default () => {
  const [currentExperience, setCurrentExperience] = useState(null);
  const { loading, variant, collections, focusedCollection } = useContext(ProductCustomizerVariantContext);

  const experiences = useMemo(() =>
    collections?.map(({selectedExperience}) => selectedExperience).filter(Boolean) ?? []
  , [collections]);

  useEffect(() => {
    if (!experiences.length) return;
    if (focusedCollection) {
      const match = collections.find(({handle}) => handle === focusedCollection);
      if (match?.selectedExperience) {
        setCurrentExperience(match.selectedExperience.handle);
        return;
      }
    }
    if (!currentExperience) {
      setCurrentExperience(experiences[0].handle);
    }
  }, [focusedCollection, experiences]);

  if(experiences.length === 0){
    return null;
  }

  return <div slot="auxiliary-tray">
          {loading || experiences.length == 0 ?
            "Loading"
          :
            <>
              {experiences.map((selectedExperience) => <div className={`customizer-experience`} data-active={selectedExperience.handle == currentExperience ? '' : null} data-handle={selectedExperience.handle}>
                <AjaxPage handle={selectedExperience.page?.reference?.handle} requestSectionContent/>
              </div>)}
            </>
          }
      </div>
}
